<div *ngFor="let guide of guides; let i = index">
  <app-track-guide-detail [guide]="guide" [isDialog]="dialogParams?.guides?.length"></app-track-guide-detail>
  <hr>
</div>